import React from "react";
import { Helmet } from "react-helmet";

const Index = () => {
    return (
        <>
        <Helmet>
            <title>Compare best price insaurance</title>
        </Helmet>
            <header>
            <div className="max-w-7xl mx-auto mt-4 flex flex-col-reverse lg:flex-row items-center px-3 md:px-7 lg:px-2">
                <div className="lg:flex-1">
                <h1 className="text-3xl text-center lg:text-start md:text-6xl leading-[1.2] font-bold">
                    The smarter way to <br />
                    buy insurance
                </h1>
                <p className="mt-2 md:mt-4 lg:mt-8 text-center lg:text-start md:text-xl">
                    Select a product to compare quotes:
                </p>

                {/* ========Card section======= */}
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-4">
                    {/* card 1 */}
                    <a
                    href="compare-life-insurance.html"
                    className="h-20 flex gap-4 items-center px-3 rounded-lg sw-one hover:scale-105 duration-300"
                    >
                    <img src="image/icon/life.png" className="w-12" alt="Life" />
                    <p className="text-xl font-bold">Life</p>
                    </a>
                    {/* card 2 */}
                    <a
                    href="health-insurance.html"
                    className="h-20 flex gap-4 items-center px-3 rounded-lg sw-one hover:scale-105 duration-300"
                    >
                    <img src="image/icon/health.png" className="w-12" alt="Health" />
                    <p className="text-xl font-bold">Health</p>
                    </a>
                    {/* card 3 */}
                    <a
                    href="travel-insurance.html"
                    className="h-20 flex gap-4 items-center px-3 rounded-lg sw-one hover:scale-105 duration-300"
                    >
                    <img src="image/icon/travel.png" className="w-12" alt="Travel" />
                    <p className="text-xl font-bold">Travel</p>
                    </a>
                    {/* card 4 */}
                    <a
                    href="business-insurance.html"
                    className="h-20 flex gap-4 items-center px-3 rounded-lg sw-one hover:scale-105 duration-300"
                    >
                    <img
                        src="image/icon/accident.png"
                        className="w-12"
                        alt="Accident"
                    />
                    <p className="text-xl font-bold">Accident</p>
                    </a>
                    {/* card 5 */}
                    <a
                    href="cheap-car-automobile-quotes.html"
                    className="h-20 flex gap-4 items-center px-3 rounded-lg sw-one hover:scale-105 duration-300"
                    >
                    <img
                        src="image/icon/car-accident.png"
                        className="w-12"
                        alt="Car"
                    />
                    <p className="text-xl font-bold">Car</p>
                    </a>
                    {/* card 6 */}
                    <a
                    href="house-insurance.html"
                    className="h-20 flex gap-4 items-center px-3 rounded-lg sw-one hover:scale-105 duration-300"
                    >
                    <img
                        src="image/icon/motorcycle.png"
                        className="w-12"
                        alt="Motorcycle"
                    />
                    <p className="text-xl font-bold hidden md:block">Motorcycle</p>
                    <p className="text-xl font-bold md:hidden">Bike</p>
                    </a>
                </div>
                </div>
                <div className="lg:flex-1">
                <img className="w-[400px] md:w-[600px] lg:h-full" src="image/hero-img.svg" alt="Hero" />
                </div>
            </div>
            </header>
            <main>
                {/* =========== Call Request Section ======= */}
                <section className="max-w-6xl lg:mx-auto mt-10 sw-one p-12 rounded-lg flex flex-col lg:flex-row gap-4 md:gap-10 justify-between mx-3 md:mx-7">
                <h2 className="text-xl text-center md:text-start md:text-2xl font-semibold">Request for a phone call</h2>
                <div className="flex flex-col md:flex-row gap-4">
                    <div className="border-2 border-blue rounded-lg flex gap-4 py-1.5 px-2 w-full">
                        <img className="w-6" src="image/icon/phone-call.png" alt="" />
                        <input
                            type="text"
                            placeholder="Phone Number"
                            className="bg-transparent outline-none"
                        />
                    </div>
                    <select className="border-2 border-blue rounded-lg outline-none p-2 w-full">
                        <option disabled selected>Topic</option>
                        <option>Insurance Policies</option>
                        <option>Corporate Solutions</option>
                        <option>Claim Assistance</option>
                        <option>Enrollment</option>
                    </select>
                    <input className="bg-blue px-12 py-2 rounded-lg text-white font-semibold" type="submit" value="Submit" />
                </div>
                </section>

                {/*====== Why trust us ===== */}
                <section className="max-w-7xl mx-auto mt-32 mb-12 px-3 md:px-7 lg:px-2">
                <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 lg:mb-0">Why trust Insurance Cart?</h2>
                <div className="grid grid-cols-1 lg:grid-cols-3">
                    {/* section 1 */}
                    <div className="lg:pr-10">
                        <div>
                            <h3 className="text-xl font-bold mb-2">Smart tools</h3>
                            <p>
                                Our proprietary technology makes it easy to compare personalized
                                quotes and policies from top-rated insurers side by side.
                            </p>
                        </div>
                        <div className="mt-12">
                            <h3 className="text-xl font-bold mb-2">Human support</h3>
                            <p>
                                Our team of licensed experts is here to answer questions, handle
                                paperwork, and help you make decisions with confidence.
                            </p>
                        </div>
                    </div>
                    {/* section 2 */}
                    <div>
                        <img src="image/why-trust.svg" alt="Why Trust Us" />
                    </div>

                    {/* section 3 */}
                    <div className="lg:pl-10">
                        <div>
                            <h3 className="text-xl font-bold mb-2">Fully independent</h3>
                            <p>
                                We work for you — not for the insurance companies. From exploring
                                coverage options to making policy adjustments as your life changes,
                                we're your advocate at every step.
                            </p>
                        </div>
                        <div className="mt-12">
                            <h3 className="text-xl font-bold mb-2">Security you can trust</h3>
                            <p>
                                Your security is our priority. We use industry-leading security
                                practices to help keep your information safe.
                            </p>
                        </div>
                    </div>
                </div>
                </section>

                {/* =========  Our guides ======== */}
                <section className="max-w-7xl mx-auto mb-32 px-3 md:px-7 lg:px-2">
                    <h2 className="text-2xl md:text-3xl font-bold text-center">Explore our guides</h2>
                    <p className="text-center mt-3 md:mt-4">
                        Our experts have compiled resources that cover the basics and beyond.
                    </p>
                    <div className="mt-4 md:mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {/* card 1 */}
                        <div className="card bg-base-100 sw-one rounded-xl hover:scale-105 duration-500">
                            <figure>
                                <img src="image/life-insurance-guide.webp" alt="" />
                            </figure>
                            <div className="card-body px-5">
                                <h2 className="card-title font-bold">Life insurance</h2>
                                <p>Everything you need to know about life insurance</p>
                            </div>
                        </div>
                        {/* card 2 */}
                        <div className="card bg-base-100 sw-one rounded-xl hover:scale-105 duration-500">
                            <figure>
                                <img src="image/home-insurance-guide.webp" alt="" />
                            </figure>
                            <div className="card-body px-5">
                                <h2 className="card-title font-bold">Home insurance</h2>
                                <p>Your homeowner's Insurance Cart questions, answered</p>
                            </div>
                        </div>
                        {/* card 3 */}
                        <div className="card bg-base-100 sw-one rounded-xl hover:scale-105 duration-500">
                            <figure>
                                <img src="image/auto-insurance-guide.webp" alt="" />
                            </figure>
                            <div className="card-body px-5">
                                <h2 className="card-title font-bold">Auto insurance</h2>
                                <p>Ins and outs of financially protecting your vehicle</p>
                            </div>
                        </div>
                        {/* card 4 */}
                        <div className="card bg-base-100 sw-one rounded-xl hover:scale-105 duration-500">
                            <figure>
                                <img src="image/disability-insurance-guide.webp" alt="" />
                            </figure>
                            <div className="card-body px-5">
                                <h2 className="card-title font-bold">Disability insurance</h2>
                                <p>Answers to your disability insurance questions</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ========= Support section ======== */}
                <section className="grid grid-cols-1 lg:grid-cols-2 items-center border border-gray-100 mb-32">
                    <img className="bg-[#E7E5E3]" src="image/Easy-process.webp" alt="" />
                    <div className="px-3 md:px-7 py-5 md:py-10 lg:p-10">
                        <h1 className="text-3xl font-bold">Easy process, expert support</h1>
                        <p className="mt-4 md:mt-6 mb-6 md:mb-12">Insurance Cart provides free quotes tailored to your needs with support from licensed agents, helping you get insurance coverage fast so you can get on with life.</p>
                        <div className="text-center flex justify-between items-center">
                            <div>
                                <p className="font-black text-2xl md:text-6xl text-blue">30M+</p>
                                <p className="font-bold text-sm mt-3">shoppers served</p>
                            </div>
                            <div>
                                <p className="font-black text-2xl md:text-6xl text-blue">$90B</p>
                                <p className="font-bold text-sm mt-3">of life insurance sold</p>
                            </div>
                            <div>
                                <p className="font-black text-2xl md:text-6xl text-blue">24/7</p>
                                <p className="font-bold text-sm mt-3">help from experts</p>
                            </div>
                        </div>
                    </div>
                    <div className="px-3 md:px-7 py-5 md:py-10 lg:p-14">
                        <h1 className="text-3xl font-bold">Finished scrolling? Start saving</h1>
                        <p className="mt-6 mb-12">Find the insurance you need and save by shopping from the most trusted insurers.</p>
                        <div className="flex flex-col md:flex-row gap-4">
                            <button className="bg-blue px-4 py-2 font-semibold text-white rounded-full">Shop life insurance</button>
                            <button className="bg-blue px-4 py-2 font-semibold text-white rounded-full">Shop home & auto insurance</button>
                        </div>
                    </div>
                    <img src="image/find-your.webp" alt="" />
                </section>

                {/* ========== FAQ section ========== */}
                <section className="max-w-7xl mx-auto px-3 md:px-7 lg:px-2">
                <h2 className="text-2xl md:text-3xl font-bold text-center">
                    Frequently asked questions?
                </h2>
                <div className="grid grid-cols-11 gap-8 mt-6 md:mt-12 items-center">
                    <div className="join join-vertical w-full col-span-11 lg:col-span-7 order-4 lg:order-3">
                        <div className="collapse collapse-arrow join-item border">
                            <input type="radio" name="my-accordion-4" id="faq1" defaultChecked />
                            <div className="collapse-title text-xl font-medium">
                                How is Insurance Cart different from other insurance sites?
                            </div>
                            <div className="collapse-content">
                                <p>
                                    Insurance Cart is an insurance marketplace, not an insurance
                                    company. (That means we sell policies, we don't underwrite
                                    them.) There's no shortage of companies out there offering
                                    fast or easy insurance coverage, but we think a marketplace is
                                    the best way to compare them all — and Insurance Cart combines
                                    that marketplace experience with online tools, an expansive
                                    educational library, and guidance from real, licensed humans
                                    to help you get covered with confidence.
                                </p>
                            </div>
                        </div>
                        <div className="collapse collapse-arrow join-item border ">
                            <input type="radio" name="my-accordion-4" id="faq2" />
                            <div className="collapse-title text-xl font-medium">
                                How does Insurance Cart make money?
                            </div>
                            <div className="collapse-content">
                                <p>
                                    We’re an independent insurance broker, so we get paid a
                                    commission by insurance companies for each sale. Insurance
                                    commissions are already built into the price of an insurance
                                    policy, so you’re not paying any extra for working with us to
                                    buy a policy. Our compensation on any particular purchase may
                                    vary depending on a number of factors, including the type and
                                    size of product, the insurer, and the volume of business we
                                    have with an insurer, but we don't push for or give preference
                                    to any one insurer over another because of the commission.
                                    We're here to fight for you, not for ourselves. (Want to know
                                    what commission we'd earn on a specific insurance policy you
                                    see in our marketplace? Just ask!)
                                </p>
                            </div>
                        </div>
                        <div className="collapse collapse-arrow join-item border ">
                            <input type="radio" name="my-accordion-4" id="faq3" />
                            <div className="collapse-title text-xl font-medium">
                                Is Insurance Cart licensed?
                            </div>
                            <div className="collapse-content">
                                <p>
                                    Yes! All insurance brokers are required by law to be licensed
                                    in each state they do business. You can find our licenses
                                    here.
                                </p>
                            </div>
                        </div>
                        <div className="collapse collapse-arrow join-item border ">
                            <input type="radio" name="my-accordion-4" id="faq4" />
                            <div className="collapse-title text-xl font-medium">
                                Is Insurance Cart a corporate affiliate of any insurance
                                company?
                            </div>
                            <div className="collapse-content">
                                <p>
                                    No. We’re an independent insurance broker, which means that
                                    we're not owned by an insurance company, nor do we own one.
                                    Instead, we sell insurance policies from multiple insurers
                                    without bias or favor toward any of them. It’s important to us
                                    that we help you find the right insurance policy for your
                                    needs — not which company you buy it from.
                                </p>
                            </div>
                        </div>
                        <div className="collapse collapse-arrow join-item border ">
                            <input type="radio" name="my-accordion-4" id="faq5" />
                            <div className="collapse-title text-xl font-medium">
                                Is it cheaper to buy insurance through Insurance Cart?
                            </div>
                            <div className="collapse-content">
                                <p>
                                    Insurance rates are regulated by law, which means that no
                                    company, broker, or agent can offer you a discount on a
                                    policy. That doesn't mean you can't find ways to save money,
                                    though! Each insurer calculates risk differently, and they all
                                    strive to offer policies at competitive prices. That's why
                                    Insurance Cart helps you compare quotes from multiple
                                    companies in one place: to make it easy to spot potential
                                    savings.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* Image section */}
                    <div className="col-span-11 lg:col-span-4 order-3 lg:order-4">
                        <img
                            className="w-full rounded-lg"
                            src="image/4456158_2358405.svg"
                            alt="FAQ illustration"
                        />
                    </div>
                </div>
            </section>
            </main>
        </>
    );
};

export default Index;
